import { WeekdayNamePipe } from './../pipes/weekday-name.pipe';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastComponent } from '../components/toast/toast.component';
import { ToastrModule } from 'ngx-toastr';
import { PaginationComponent } from '../components/common/pagination/pagination.component';
import { PhonenumberPipe } from '../pipes/phonenumber.pipe';
import { LoadingComponent } from '../components/loading/loading.component';
import { CalenderViewComponent } from '../components/calender-view/calender-view.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { NgbDatepickerModule, NgbModalModule, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MakeAppointmentDialogueComponent } from '../components/make-appointment-dialogue/make-appointment-dialogue.component';
import { ConfirmationDialogueComponent } from '../components/confirmation-dialogue/confirmation-dialogue.component';
import { MDsAppointmentComponent } from '../components/make-appointment-dialogue/mds-appointment/mds-appointment.component';
import { MRIAppointmentComponent } from '../components/make-appointment-dialogue/mriappointment/mriappointment.component';
import { NeuroAppointmentComponent } from '../components/make-appointment-dialogue/neuro-appointment/neuro-appointment.component';
import { OrthoAppointmentComponent } from '../components/make-appointment-dialogue/ortho-appointment/ortho-appointment.component';
import { WeekPickerComponent } from '../components/week-picker/week-picker.component';
import { DateRangePickerComponent } from '../components/date-range-picker/date-range-picker.component';
import { AddEditPatientDialogueComponent } from '../components/add-edit-patient-dialogue/add-edit-patient-dialogue.component';
import { VisitorStatusDialogueComponent } from '../components/visitor-status-dialogue/visitor-status-dialogue.component';
import { PainManagementComponent } from '../components/make-appointment-dialogue/pain-management/pain-management/pain-management.component';

const ModuleImports = [
  CommonModule,
  ToastrModule.forRoot(),
  FormsModule,
  ReactiveFormsModule,
  CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
  NgbModalModule,
  NgbNavModule,
  NgbTooltipModule,
  NgbDatepickerModule
];
const DaclarationsImports = [
  ToastComponent,
  PaginationComponent,
  LoadingComponent,
  CalenderViewComponent,
  MakeAppointmentDialogueComponent,
  AddEditPatientDialogueComponent,
  ConfirmationDialogueComponent,
  MDsAppointmentComponent,
  MRIAppointmentComponent,
  NeuroAppointmentComponent,
  OrthoAppointmentComponent,
  PainManagementComponent,
  WeekPickerComponent,
  DateRangePickerComponent,
  VisitorStatusDialogueComponent
];
const PipesImports = [PhonenumberPipe, WeekdayNamePipe];

@NgModule({
  declarations: [...DaclarationsImports, ...PipesImports],
  imports: ModuleImports,
  exports: [ModuleImports, DaclarationsImports, PipesImports],
  providers: [DatePipe]
})
export class SharedModule {}
